<!--资产调拨申请单-->
<template>
  <div class="TransferDiv">
    <van-form ref="formRef">
      <van-cell-group inset style="margin: 1vh 1.2vh 0 1.2vh">
        <span class="textFontSize">
          <van-icon class="lable_icon" name="star" />申请人
        </span>
        <van-field
          style="padding-top: 0"
          v-model="pageConfig.apply_emp_info"
          name="申请人"
          disabled
        />
        <div class="boxContent"></div>
        <span class="textFontSize">
          <van-icon class="lable_icon" name="star" />部门
        </span>
        <van-field
          style="padding-top: 0"
          v-model="pageConfig.dept_name"
          name="部门"
          disabled
        />
        <div class="boxContent"></div>
        <span class="textFontSize">
          <van-icon class="lable_icon" name="star" />公司
        </span>
        <van-field
          style="padding-top: 0"
          v-model="pageConfig.company_name"
          name="公司"
          readonly
          placeholder="请选择公司"
          :rules="[{ required: true, message: '请选择公司' }]"
          @click="pageConfig.showCompanyPop = true"
        />
        <van-popup
          v-model:show="pageConfig.showCompanyPop"
          position="bottom"
          round
        >
          <van-picker
            :columns="pageConfig.companyList"
            @confirm="methods.changeCompany"
            @cancel="pageConfig.showCompanyPop = false"
          >
          </van-picker>
        </van-popup>        
        <div class="boxContent"></div>
        <span class="textFontSize">
          <van-icon class="lable_icon" name="star" />调拨明细
        </span>
        <div class="vant-table">
          <table
            cellspacing="0"
            :style="bgcolor"
            style="width: 2000px"
            class="table"
          >
            <tr>
              <th class="th" width="40px">序号</th>
              <th class="th" width="50px">操作</th>
              <th class="th" width="120px">调拨资产</th>
              <th class="th" width="100px">资产代码</th>
              <th class="th" width="200px">原保管部门</th>
              <th class="th" width="100px">原保管人</th>
              <th class="th" width="100px">原资产状态</th>
              <th class="th" width="180px">原位置</th>
              <th class="th" width="180px">原站点</th>
              <th class="th" width="100px">新保管人</th>
              <th class="th" width="250px">新保管部门</th>
              <th class="th" width="100px">新资产状态</th>
              <th class="th" width="180px">新位置</th>
              <th class="th" width="180px">新站点</th>
            </tr>
            <tr
              v-for="(item, index) in pageConfig.transfer_detail_list"
              :key="index"
              class="list-tr"
              @click="methods.selectTransferRow(item)"
            >
              <td>
                {{ index + 1 }}
              </td>
              <td>
                <span
                  class="link-text"
                  @click.stop="methods.deleteTransferRow(item.id)"
                  >删除</span
                >
              </td>
              <!-- 资产名称 -->
              <td>
                <van-field
                  v-model="item.asset_name"
                  readonly
                  placeholder="点击选择"
                />
              </td>
              <!-- 资产代码 -->
              <td>
                {{ item.asset_code }}
              </td>
              <!-- 原保管部门名称 -->
              <td>
                {{ item.custodian_dept_name }}
              </td>
              <!-- 保管人姓名 -->
              <td>
                {{ item.custodian_emp_name }}
              </td>
              <!-- 资产状态名称 -->
              <td>
                {{ item.asset_status_name }}
              </td>
              <!-- 原位置 -->
              <td>
                {{ item.asset_location }}
              </td>
              <!-- 原站点 -->
              <td>
                {{ item.station_name }}
              </td>
              <!-- 新保管人 -->
              <td>
                {{ item.new_custodian_emp_name }}
              </td>
              <!-- 新保管部门 -->
              <td>
                {{ item.new_custodian_dept_name }}
              </td>
              <!-- 新资产状态 -->
              <td>
                {{ item.new_asset_status_name }}
              </td>
              <!-- 新位置 -->
              <td>
                {{ item.new_asset_location }}
              </td>
              <!-- 新站点 -->
              <td>
                {{ item.new_station_name }}
              </td>
            </tr>
          </table>
          <van-button
            icon="plus"
            size="small"
            @click="methods.addAwardRow"
            type="default"
            >添加</van-button
          >
        </div>
        <div class="boxContent"></div>
        <CounterSign
          style="height: auto"
          :applyEmp="pageConfig.applyEmp"
          :isreadonly="true"
          :showLabel="item.status_name"
          :defaultEmpList="item.list"
          @empTOListChange="
            (res) => {
              methods.empTOListChange(res, item.status_id)
            }
          "
          v-for="item in pageConfig.counterSignList"
          :key="item.status_id"
        ></CounterSign>
        <div class="boxContent"></div>
        <span
          style="margin-left: 1vh; margin-top: 2vh; display: block; color: #000"
        >
          <van-icon class="lable_icon" name="上传附件" />上传附件
        </span>
        <div class="upload-file">
          <van-uploader
            :after-read="methods.uploadFile"
            multiple
            accept="*"
            v-model="pageConfig.fileList"
          />
        </div>
        <div class="boxContent"></div>
        <span class="textFontSize">
          <van-icon class="lable_icon" name="star"/>申请原因
        </span>
        <van-field
          v-model="pageConfig.apply_reason"
          placeholder="请输入申请原因..."
          type="textarea"
          rows="3"
          :show-word-limit="true"
          :rules="[{ required: true, message: '请选择申请原因' }]"
          maxlength="500"
          name="申请原因"
        />
        <div class="boxContent"></div>
        <span class="textFontSize"> <van-icon class="lable_icon" />备注 </span>
        <van-field
          v-model="pageConfig.remark"
          placeholder="请输入备注..."
          type="textarea"
          rows="3"
          :show-word-limit="true"
          maxlength="500"
          name="备注"
        />
      </van-cell-group>
    </van-form>
    <van-overlay :show="pageConfig.loadding" style="z-index: 9999999999"
      ><van-loading type="spinner" color="#1989fa" />
    </van-overlay>
    <div class="bottom" style="z-index: 100">
      <van-button
        type="primary"
        block
        style="border-radius: 10px; margin-top: 1vh"
        @click="methods.applySubmit"
        >提交
      </van-button>
    </div>
    <van-popup
      v-model:show="pageConfig.showTransferPop"
      position="bottom"
      full-screen
      :style="{ height: '100%' }"
    >
      <TransferPop
        @onclose="methods.saveTransfer"
        :rowdata="pageConfig.transferRow"
        :apply_emp_id="pageConfig.apply_emp_id"
        :company_id="pageConfig.company_id"
        v-if="pageConfig.showTransferPop"
      ></TransferPop>
    </van-popup>
    <div class="bottom" style="z-index: 100">
      <van-button
        type="primary"
        block
        style="border-radius: 10px; margin-top: 1vh"
        @click="methods.applySubmit"
        >提交
      </van-button>
    </div>
  </div>
</template>
<script>
import { useRouter } from 'vue-router'
import { reactive, onMounted, ref } from 'vue'
import CounterSign from '@/components/Emp/counterSign.vue'
import { GetEmpDeptInfo } from '@/api/ehr_emp.js' //emp的接口
import { UploadBase64 } from '@/api/oaApi.js'
import EmpSelect from '@/components/Emp/empSelect.vue'
import moment from 'moment'
import TransferPop from './transferPop.vue'

import {
  GetCompanyList,
  GetDictData,
  GetCounterSignStatus,
  GetDirectSupervisor,
  CallIPassService,
} from '@/api/oawfs.js' //wfs
import { Toast, Dialog } from 'vant'
export default {
  props: ['applyEmp', 'formCode'],
  components: { 'emp-select': EmpSelect, CounterSign, TransferPop },
  setup(props) {
    //当前时间
    const nowTime = new Date()
    //当前日期
    const nowDate =
      nowTime.getFullYear() +
      '/' +
      (nowTime.getMonth() + 1) +
      '/' +
      nowTime.getDate()
    const router = useRouter()
    //参数配置
    const pageConfig = reactive({
      loadding: false, //加载效果
      applyEmp: props.applyEmp, //申请人
      formCode: props.formCode, //表单代码
      company_id: '', //公司id
      company_code: '', //公司code
      apply_emp_info: '', //申请人信息
      apply_emp_id: '', //申请人id
      apply_emp_code: '', //申请人工号
      dept_name: '', //部门名称
      dept_id: '', //部门id
      dept_code: '', //部门代码
      counterSignList: [], //自选审批列表
      companyList: [], //公司列表
      showCompanyPop: false, //公司选择弹窗
      company_name: '', //公司名称
      company_id: '', //公司id
      company_code: '', //公司代码
      apply_reason: '', //申请原因
      remark: '', //备注
      transfer_detail_list: [
        {
          id: '1',
          asset_id: '', //资产id
          asset_name: '', //资产名称
          asset_code: '', //资产代码
          custodian_dept_name: '', //保管部门名称
          custodian_emp_id: '', //保管人id
          custodian_emp_name: '', //保管人名称
          asset_status: '', //原资产状态
          asset_status_name: '', //原资产状态
          asset_location: '', //原位置
          station_code: '', //原站点
          new_custodian_dept_id: '', //新保管部门id
          new_custodian_dept_code: '', //新保管部门代码
          new_custodian_dept_name: '', //新保管部门
          new_custodian_emp_id: '', //新保管人id
          new_custodian_emp_code: '', //新保管人工号
          new_asset_status: '', //新资产状态
          new_asset_location: '', //新位置
          new_station_code: '', //新站点
          new_station_name: '', //新站点名称
        },
      ], //调拨明细
      showTransferPop: false, //调拨弹窗
      transferRow: null, //当前行
      fileList: [], //附件列表
    })
    //表单验证
    const formRef = ref('')
    //内置函数
    const methods = {
      //初始化
      init: function () {
        pageConfig.fill_emp_id = props.applyEmp.emp_id
        pageConfig.fill_emp_info =
          props.applyEmp.emp_code + '-' + props.applyEmp.emp_name
        pageConfig.apply_emp_id = props.applyEmp.emp_id
        pageConfig.apply_emp_info =
          props.applyEmp.emp_code + '-' + props.applyEmp.emp_name
        pageConfig.apply_emp_code = props.applyEmp.emp_code
        //获取员工部门
        methods.getEmpDept()
        //获取公司信息
        methods.getCompanyList()
        //获取自选审批列表
        methods.getCounterSignStatus()
      },
      //更新申请人
      changeApplyEmp: function (item) {
        pageConfig.apply_emp_id = item.id
        pageConfig.emp_code = item.emp_code
        pageConfig.apply_emp_code = item.emp_code
        pageConfig.apply_emp_info = item.emp_code + '-' + item.emp_name
        pageConfig.apply_emp_name = item.emp_name
        //获取员工部门
        methods.getEmpDept()

        pageConfig.transfer_detail_list = [
          {
            id: '1',
            asset_id: '', //资产id
            asset_name: '', //资产名称
            asset_code: '', //资产代码
            custodian_dept_name: '', //保管部门名称
            custodian_emp_id: '', //保管人id
            custodian_emp_name: '', //保管人名称
            asset_status: '', //原资产状态
            asset_status_name: '', //原资产状态
            asset_location: '', //原位置
            station_code: '', //原站点
            new_custodian_dept_id: '', //新保管部门id
            new_custodian_dept_code: '', //新保管部门代码
            new_custodian_dept_name: '', //新保管部门
            new_custodian_emp_id: '', //新保管人id
            new_custodian_emp_code: '', //新保管人工号
            new_asset_status: '', //新资产状态
            new_asset_location: '', //新位置
            new_station_code: '', //新站点
            new_station_name: '', //新站点名称
          },
        ]
        pageConfig.company_id = ''
        pageConfig.company_code = ''
        pageConfig.company_name = ''
        pageConfig.counterSignList = []
        //获取自选
        methods.getCounterSignStatus()
      },
      //获取员工部门
      getEmpDept: function () {
        GetEmpDeptInfo({ empId: pageConfig.apply_emp_id }).then((res) => {
          if (res.code == 200 && res.data) {
            pageConfig.dept_name = res.data.dept_code + '-' + res.data.dept_name
            pageConfig.dept_code = res.data.dept_code
            pageConfig.dept_id = res.data.dept_id
          }
        })
      },
      //获取公司列表
      getCompanyList: function () {
        pageConfig.companyList = []
        GetCompanyList().then((res) => {
          if (res.code == 200) {
            res.data.forEach((item) => {
              pageConfig.companyList.push({
                text: item.company_name,
                code: item.company_code,
                value: item.id,
              })
            })
          }
        })
      },
      //时间转换
      convertTime: function (time) {
        if (time != '') {
          return moment(time).format('YYYY-MM-DD')
        }
      },
      //获取自选审批列表
      getCounterSignStatus: function () {
        GetCounterSignStatus({ formCode: 'FI0006' }).then((res) => {
          if (res.code == 200) {
            {
              pageConfig.counterSignList = res.data
            }
          }
        })
      },
      //获取guid
      guid: function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
          /[xy]/g,
          function (c) {
            var r = (Math.random() * 16) | 0,
              v = c == 'x' ? r : (r & 0x3) | 0x8
            return v.toString(16)
          },
        )
      },
      //自选人
      empTOListChange: function (item, id) {
        if (item) {
          pageConfig.counterSignList.forEach((element) => {
            if (element.status_id == id) {
              element.list = item
              return
            }
          })
        }
      },
      //选择公司
      changeCompany: function (res) {
        pageConfig.company_code = res.code
        pageConfig.company_name = res.text
        pageConfig.company_id = res.value
        pageConfig.showCompanyPop = false

        //清理表单内容
        pageConfig.transfer_detail_list = [
          {
            id: '1',
            asset_id: '', //资产id
            asset_name: '', //资产名称
            asset_code: '', //资产代码
            custodian_dept_name: '', //保管部门名称
            custodian_emp_id: '', //保管人id
            custodian_emp_name: '', //保管人名称
            asset_status: '', //原资产状态
            asset_status_name: '', //原资产状态
            asset_location: '', //原位置
            station_code: '', //原站点
            new_custodian_dept_id: '', //新保管部门id
            new_custodian_dept_code: '', //新保管部门代码
            new_custodian_dept_name: '', //新保管部门
            new_custodian_emp_id: '', //新保管人id
            new_custodian_emp_code: '', //新保管人工号
            new_asset_status: '', //新资产状态
            new_asset_location: '', //新位置
            new_station_code: '', //新站点
            new_station_name: '', //新站点名称
          },
        ]
        pageConfig.counterSignList = []
        //获取自选
        methods.getCounterSignStatus()
      },
      //选择调拨行
      selectTransferRow: function (row) {
        if (!pageConfig.company_id) {
          Toast('请先选择公司')
          return
        }
        pageConfig.transferRow = row
        pageConfig.showTransferPop = true
      },
      //保存调拨选择
      saveTransfer: function (data, row) {
        pageConfig.showTransferPop = false
        if (
          pageConfig.transfer_detail_list.find(
            (x) => x.asset_id === data.asset_id && x.id !== row.id,
          )
        ) {
          Toast('该资产已经在列表之中')
          return false
        }
        pageConfig.transfer_detail_list.forEach((element) => {
          if (element.id == row.id) {
            element.id = methods.guid()
            element.asset_id = data.asset_id //资产id
            element.asset_name = data.asset_name //资产名称
            element.asset_code = data.asset_code //资产代码
            element.custodian_dept_id = data.custodian_dept_id //保管部门id
            element.custodian_dept_name = data.custodian_dept_name //保管部门名称
            element.custodian_emp_name = data.custodian_emp_name //保管人名称
            element.custodian_emp_id = data.custodian_emp_id //保管人id
            element.asset_status = data.asset_status //原资产状态
            element.asset_status_name = data.asset_status_name //原资产状态
            element.asset_location = data.asset_location //原位置
            element.station_code = data.station_code //原站点
            element.new_custodian_emp_code = data.new_custodian_emp_code
            element.new_custodian_emp_name = data.new_custodian_emp_name //新保管人
            element.new_custodian_emp_id = data.new_custodian_emp_id //新保管人
            element.new_custodian_dept_name = data.new_custodian_dept_name //新保管部门
            element.new_custodian_dept_code = data.new_custodian_dept_code //新保管部门
            element.new_custodian_dept_id = data.new_custodian_dept_id //新保管部门
            element.new_asset_status_name = data.new_asset_status_name //新资产状态
            element.new_asset_status = data.new_asset_status //新资产状态
            element.new_asset_location = data.new_asset_location //新位置
            element.location_mapping = data.location_mapping //新位置
            element.new_station_name = data.new_station_name //新站点
            element.new_station_code = data.new_station_code //新站点
            return
          }
        })
        //默认调拨前自选
        methods.defaultOldCounterSign()
        //默认调拨后自选
        methods.defaultNewCounterSign()
      },
      //新增行
      addAwardRow: function () {
        pageConfig.transfer_detail_list.push({
          id: methods.guid(),
          asset_id: '', //资产id
          asset_name: '', //资产名称
          asset_code: '', //资产代码
          custodian_dept_name: '', //保管部门名称
          custodian_emp_name: '', //保管人名称
          custodian_emp_id: '', //保管人id
          asset_status: '', //原资产状态
          asset_status_name: '', //原资产状态
          asset_location: '', //原位置
          station_code: '', //原站点
          new_custodian_dept_id: '', //新保管部门id
          new_custodian_dept_code: '', //新保管部门代码
          new_custodian_dept_name: '', //新保管部门
          new_custodian_emp_id: '', //新保管人id
          new_custodian_emp_code: '', //新保管人工号
          new_custodian_emp_name: '', //新保管人
          new_asset_status: '', //新资产状态
          new_asset_location: '', //新位置
          new_station_code: '', //新站点
        })
      },
      //删除行
      deleteTransferRow: function (rowid) {
        if (pageConfig.transfer_detail_list.length <= 1) {
          Toast('至少留一条调拨明细')
          return
        }
        //找到删除的索引
        let index = pageConfig.transfer_detail_list.findIndex(
          (x) => x.id == rowid,
        )
        //移除
        pageConfig.transfer_detail_list.splice(index, 1)
        //默认调拨前自选
        methods.defaultOldCounterSign()
        //默认调拨后自选
        methods.defaultNewCounterSign()
      },
      //默认调拨前自选
      defaultOldCounterSign: function () {
        //默认原资产保管人
        methods.defaultCustodianCounterSign()
        //默认原部门资产管理员
        methods.defaultAdminCounterSign()
        //默认原部门管理员
        methods.defaultDeptManageCounterSign()
      },
      //默认调拨后自选
      defaultNewCounterSign: function () {
        //默认新资产保管人
        methods.defaultNewCustodianCounterSign()
        //默认新部门资产管理员
        methods.defaultNewAdminCounterSign()
        //默认新部门管理员
        methods.defaultNewDeptManageCounterSign()
      },
      //默认原资产保管人
      defaultCustodianCounterSign: function () {
        let list = []
        const userIdSet = new Set()
        pageConfig.transfer_detail_list.forEach((element) => {
          if (element.custodian_emp_id) {
            if(userIdSet.has(element.custodian_emp_id)) return
            userIdSet.add(element.custodian_emp_id)
            list.push({
              user_id: element.custodian_emp_id,
              emp_name: element.custodian_emp_name.split('-')[1],
              emp_code: element.custodian_emp_name.split('-')[0],
            })
          }
        })
        pageConfig.counterSignList.forEach((item) => {
          if (item.column_code == 'countersign_custodian') {
            item.list = list
            return
          }
        })
      },
      //默认原部门资产管理员
      defaultAdminCounterSign: function () {
        let deptIdList = []
        pageConfig.transfer_detail_list.forEach((element) => {
          if (element.custodian_dept_id) {
            deptIdList.push(element.custodian_dept_id)
          }
        })
        if (deptIdList.length == 0) {
          return
        }
        let param = {
          deptIds: deptIdList.join(','),
        }
        CallIPassService('eam1001', param).then((res) => {
          if (res.code == 200) {
            if (res.data) {
              let data = JSON.parse(res.data)
              let list = []
              data.forEach((element) => {
                list.push({
                  user_id: element.emp_id,
                  emp_name: element.emp_name,
                  emp_code: element.emp_code,
                })
              })
              pageConfig.counterSignList.forEach((item) => {
                if (item.column_code == 'countersign_admin') {
                  item.list = list
                  return
                }
              })
            }
          }
        })
      },
      //获取原部门主管
      defaultDeptManageCounterSign: function () {
        let empids = []
        pageConfig.transfer_detail_list.forEach((element) => {
          if (element.custodian_emp_id) {
            empids.push(element.custodian_emp_id)
          }
        })
        if (empids.length == 0) {
          return
        }
        GetDirectSupervisor(empids.join(',')).then((res) => {
          if (res.code != 200) {
            Toast(res.msg)
            return
          }
          let list = []
          res.data.forEach((element) => {
            list.push({
              user_id: element.id,
              emp_name: element.emp_name,
              emp_code: element.emp_code,
            })
          })
          pageConfig.counterSignList.forEach((item) => {
            if (item.column_code == 'countersign_dept_manage') {
              item.list = list
              return
            }
          })
        })
      },
      //默认新资产保管人
      defaultNewCustodianCounterSign: function () {
        let list = []
        const userIdSet = new Set()
        pageConfig.transfer_detail_list.forEach((element) => {
          if (element.new_custodian_emp_id) {
            if(userIdSet.has(element.new_custodian_emp_id)) return
            userIdSet.add(element.new_custodian_emp_id)
            list.push({
              user_id: element.new_custodian_emp_id,
              emp_name: element.new_custodian_emp_name.split('-')[1],
              emp_code: element.new_custodian_emp_name.split('-')[0],
            })
          }
        })
        pageConfig.counterSignList.forEach((item) => {
          if (item.column_code == 'countersign_new_custodian') {
            item.list = list
            return
          }
        })
      },
      //默认新部门资产管理员
      defaultNewAdminCounterSign: function () {
        let deptIdList = []
        pageConfig.transfer_detail_list.forEach((element) => {
          if (element.new_custodian_dept_id) {
            deptIdList.push(element.new_custodian_dept_id)
          }
        })
        if (deptIdList.length == 0) {
          return
        }
        let param = {
          deptIds: deptIdList.join(','),
        }
        CallIPassService('eam1001', param).then((res) => {
          if (res.code == 200) {
            if (res.data) {
              let data = JSON.parse(res.data)
              let list = []
              data.forEach((element) => {
                if (element.emp_id) {
                  list.push({
                    user_id: element.emp_id,
                    emp_name: element.emp_name,
                    emp_code: element.emp_code,
                  })
                }
              })
              pageConfig.counterSignList.forEach((item) => {
                if (item.column_code == 'countersign_new_admin') {
                  item.list = list
                  return
                }
              })
            }
          }
        })
      },
      //上传文件
      uploadFile: function (file) {
        const fileArr = []
        //多文件
        if (file.length && file.length > 1) {
          file.forEach((item) => {
            fileArr.push({
              base64: item.content.split(',')[1],
              file_name: item.file.name,
            })
          })
        } else {
          fileArr.push({
            base64: file.content.split(',')[1],
            file_name: file.file.name,
          })
        }
        pageConfig.loading = true
        UploadBase64(fileArr, 'wfs').then((res) => {
          pageConfig.loading = false
          if (res.code !== 200) {
            file.status = 'failed'
            file.message = '上传失败'
            return
          }
          //多文件上传
          if (file.length && file.length > 1) {
            res.data.forEach((item) => {
              file.forEach((ifile) => {
                if (item.file_name == ifile.file.name) {
                  ifile.id = item.id
                  return
                }
              })
            })
          } else {
            file.id = res.data[0].id
          }
        })
      },
      //获取新部门主管
      defaultNewDeptManageCounterSign: function () {
        let empids = []
        pageConfig.transfer_detail_list.forEach((element) => {
          if (element.new_custodian_emp_id) {
            empids.push(element.new_custodian_emp_id)
          }
        })
        if (empids.length == 0) {
          return
        }
        GetDirectSupervisor(empids.join(',')).then((res) => {
          if (res.code != 200) {
            Toast(res.msg)
            return
          }
          let list = []
          res.data.forEach((element) => {
            if (element.id) {
              list.push({
                user_id: element.id,
                emp_name: element.emp_name,
                emp_code: element.emp_code,
              })
            }
          })
          pageConfig.counterSignList.forEach((item) => {
            if (item.column_code == 'countersign_new_dept_manage') {
              item.list = list
              return
            }
          })
        })
      },
      //验证
      submitVerify: function () {
        if (pageConfig.transfer_detail_list.length <= 0) {
          Toast('请添加调拨明细')
          return false
        }
        let res = true
        pageConfig.transfer_detail_list.forEach((element, index) => {
          if(element.new_asset_location.length>15){
            Toast('第{' + (index + 1) + '}行新位置不能超过15个字符')
            res = false
            return false
          }
          if (!element.asset_id) {
            res = false
            Toast('第{' + (index + 1) + '}行请选择调拨的资产')
            return false
          }
          if (!element.new_custodian_emp_id) {
            res = false
            Toast('第{' + (index + 1) + '}行请选择新保管人')
            return false
          }
          if (!element.new_asset_status) {
            res = false
            Toast('第{' + (index + 1) + '}行请选择新资产状态')
            return false
          }
          if (!element.new_asset_location) {
            res = false
            Toast('第{' + (index + 1) + '}行请选择新位置')
            return false
          }       
          if (!element.new_custodian_emp_name || !element.new_custodian_emp_id) {
            res = false
            Toast('第{' + (index + 1) + '}行请选择新保管人')
            return false
          } 
          if (!element.new_custodian_dept_id || !element.new_custodian_dept_code) {
            res = false
            Toast('第{' + (index + 1) + '}行请选择新保管部门')
            return false
          }
        })
        return res
      },
      //默认自选审批人
      getCountersignParam: function () {
        let param = []
        pageConfig.counterSignList.forEach((element) => {
          if (element.list && element.list.length > 0) {
            element.list.forEach((item, index) => {
              param.push({
                status_id: element.status_id,
                is_cc: element.status_type == 1 ? 'N' : 'Y',
                handler_emp_id: item.user_id,
                sort_num: index + 1,
              })
            })
          }
        })
        return param
      },
      //获取提交参数
      getSubmitParam: function () {
      //上传附件
        let fileids = []
        if (pageConfig.fileList.length > 0) {
          pageConfig.fileList.forEach((element) => {
            fileids.push(element.id)
          })
        }
        let param = {
          form_code: props.formCode,
          apply_emp_id: pageConfig.apply_emp_id, //申请人id
          apply_dept_id: pageConfig.dept_id, //申请人部门id
          fill_emp_id: pageConfig.fill_emp_id, //填单人id
          fill_emp_info: pageConfig.fill_emp_info, //填单人信息
          company_id: pageConfig.company_id, //公司
          company_code: pageConfig.company_code, //公司
          effective_date: '', //生效日期
          apply_reason: pageConfig.apply_reason, //申请原因
          remark: pageConfig.remark, //备注
          attachment_id: fileids.join(), //附件id
          transfer_details: pageConfig.transfer_detail_list, //调拨明细
          countersign_list: methods.getCountersignParam(), //获取自选审批参数
        }
        return param
      },
      //提交
      applySubmit: function (reload) {
        formRef.value.validate().then(() => {
          //数据校验
          if (!methods.submitVerify()) {
            return
          }
          let param = methods.getSubmitParam()
          Dialog.confirm({ title: '提交', message: '是否确认提交' }).then(
            () => {
              pageConfig.loadding = true
              CallIPassService('eam1002', param).then((res) => {
                if (res.code != 200) {
                  Toast(res.msg)
                  pageConfig.loadding = false
                  return
                }
                Toast.success('提交成功')
                setTimeout(function () {
                  router.push({ path: '/Todolist/3' })
                }, 1000)
              })
            },
          )
        })
      },
    }
    onMounted(() => {
      methods.init()
    })
    return {
      pageConfig,
      methods,
      formRef,
    }
  },
}
</script>
<style lang="scss" scoped>
.TransferDiv {
  .vant-table {
    :deep(.van-field__body) {
      font-size: 10px;
    }
    overflow: auto;
    table {
      padding: 5px;

      .th {
        height: 30px;
        line-height: 30px;
        background-color: #f5f6f6;
        text-align: center;
      }

      td {
        text-align: center;
        border-bottom: 1px solid #f5f6f6;
      }

      .link-text {
        color: #f56c6c;
      }
    }

    .van-button {
      margin: 0 10px;
    }
  }
  .van-loading {
    text-align: center;
    position: absolute;
    z-index: 9999999;
    width: 80px;
    height: 80px;
    line-height: 80px;
    background-color: #fff;
    border-radius: 10px;
    left: calc(50% - 40px);
    top: 25vh;
  }
  .upload-file {
    padding: 0 10px;
  }

  .bottom {
    height: 50px;
    background-color: #fff;
    width: 100%;
    position: fixed;
    bottom: 0;
    .van-button {
      width: 90%;
      margin: 0 auto;
    }
  }
}
</style>
